/**
 * Small, client-safe formatters for the staff panels.
 *
 * `lib/utils.ts` already owns absolute date formatting. What the console needs in
 * addition is "how long has this been waiting", which is the question every ops
 * screen asks — and it must be identical on every screen, because two screens
 * disagreeing about an incident's age sends someone hunting the wrong bug.
 */

/** Whole minutes between `iso` and now, or null when there is no timestamp. */
export function minutesSince(iso: string | null | undefined): number | null {
  if (!iso) return null;
  const ms = Date.parse(iso);
  if (Number.isNaN(ms)) return null;
  return Math.max(0, Math.round((Date.now() - ms) / 60_000));
}

/** "just now" / "12m ago" / "3h ago" / "2d ago", or an em dash when unknown. */
export function relativeTime(iso: string | null | undefined): string {
  const minutes = minutesSince(iso);
  if (minutes === null) return '—';
  if (minutes < 1) return 'just now';
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}
